
import React from 'react';
import includes from 'lodash/includes';

import Log from '../../log';
const log = Log.getLogger('MultiSceneForApp.core.parameters.ParameterItemGeneric');

const ParameterItemGeneric = (props
    /* Note: do not remove this comment
    {
    generatePolygonDefinition,
    id,
    options,
    value,
    values,
    title,
    type,
    paramDefinitions,
    tempFeature,
    onConfirm,
    onChangeValue,
    onSetGeometry,
    onSetIsGeoActive
    }
    */
) => {

    const getComponentProps = (propNames) => {
        let componentProps = {};

        propNames.forEach(name => {
            if (props[name]) {
                componentProps[name] = props[name];
            }
        });

        const localProps = [
            'generatePolygonDefinition', 'tempFeature', 'onConfirm',
            'onChangeValue', 'onSetGeometry', 'onSetIsGeoActive'

        ]
        localProps.forEach(name => {
            if (includes(propNames, name)) {
                componentProps[name] = props[name];
            }
        });

        return componentProps;
    }

    const getParameterType = () => {
        if (!props.type) {
            if (props.values) {
                return 'ComboBox';
            } else {
                return 'TextBox';
            }
        }
        return props.type;
    }

    const getParamDefinition = () => {
        return props.paramDefinitions[getParameterType()];
    }

    let paramDefinition = getParamDefinition();
    if (paramDefinition) {
        return React.createElement(
            paramDefinition.component,
            getComponentProps(paramDefinition.props)
        );
    } else {
        log.warn(`can not determine type of parameter: ${props.type}`);
        return null;
    }
}

export default ParameterItemGeneric;
